export default "__VITE_ASSET__CRvf2rUm__"